import { FormattedAddress } from "components/address";
import { formatDate } from "lib/utils";
import Link from "next/link";
import { SubscriptionSubscriber } from "pages/admin/subscriptions/subscription/[id]";
import { SubscriberDetailsDetail } from "./SubscriberDetailsDetail";
import { SubscriptionDispatches } from "./SubscriptionDispatches";

interface Props {
  subscriptionObject: SubscriptionSubscriber;
}

export const SubscriberDetails = ({ subscriptionObject }: Props) => {
  return (
    <section className='bg-white rounded my-4 p-4 shadow'>
      <dl className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-8'>
        <SubscriberDetailsDetail title='For Subscription'>
          <Link
            href={`/admin/subscriptions/${subscriptionObject.subscription.id}`}>
            <a className='hover:underline'>
              {subscriptionObject.subscription.title}
            </a>
          </Link>
        </SubscriberDetailsDetail>
        <SubscriberDetailsDetail title='Recipient'>
          {subscriptionObject.recipient}
        </SubscriberDetailsDetail>
        <SubscriberDetailsDetail title='Created On'>
          {formatDate(new Date(subscriptionObject.created_at))}
        </SubscriberDetailsDetail>
        <SubscriberDetailsDetail title='Remaining Credits'>
          {subscriptionObject.remaining_credits}
        </SubscriberDetailsDetail>
        <SubscriberDetailsDetail title='Total Credits Bought'>
          {subscriptionObject.credits_aggregate.aggregate.count}
        </SubscriberDetailsDetail>
        <SubscriberDetailsDetail title='Address'>
          {subscriptionObject.address ? (
            <FormattedAddress address={subscriptionObject.address} />
          ) : (
            "Not yet activated"
          )}
        </SubscriberDetailsDetail>
        <SubscriberDetailsDetail title='Access Password'>
          {subscriptionObject.password}
        </SubscriberDetailsDetail>
        <SubscriptionDispatches subscriptionObject={subscriptionObject} />
      </dl>
    </section>
  );
};
